var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpenCloseRightMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.55419 8.0368L8.5542 8.03678L15.0189 2.03665L15.0189 2.03668L15.022 2.03367C15.334 1.73381 15.3242 1.24868 15.0024 0.960249C14.6987 0.687979 14.2239 0.687962 13.9202 0.960266L13.9201 0.960238L13.917 0.96317L8.00326 6.45195L2.08956 0.963171L2.08954 0.963159C1.78328 0.678949 1.29394 0.67895 0.987684 0.963159L0.987643 0.963197C0.670794 1.25737 0.670773 1.74248 0.987658 2.03664L0.987671 2.03665L7.45232 8.03678L7.45235 8.03681C7.75863 8.321 8.24793 8.32101 8.55419 8.0368Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenCloseRightMenuIcon);
export default __webpack_public_path__ + "static/media/openCloseRightMenuIcon.bc62fe3b.svg";
export { ForwardRef as ReactComponent };